import { render, staticRenderFns } from "./DivisionRecordPage.vue?vue&type=template&id=e5354c3a"
import script from "./DivisionRecordPage.vue?vue&type=script&lang=js"
export * from "./DivisionRecordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5354c3a')) {
      api.createRecord('e5354c3a', component.options)
    } else {
      api.reload('e5354c3a', component.options)
    }
    module.hot.accept("./DivisionRecordPage.vue?vue&type=template&id=e5354c3a", function () {
      api.rerender('e5354c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/division/record/DivisionRecordPage.vue"
export default component.exports